// eslint-disable-next-line no-restricted-imports
import { Tooltip as TooltipBase, TooltipProps } from '@mui/material';

import { styled } from '../styled';
import { Colors } from '../theme';

import { TooltipClasses } from './types';

export const TooltipStyled = styled(({ className, ...props }: TooltipProps) => (
  <TooltipBase {...props} classes={{ popper: className, ...props.classes }} />
))(({ theme }) => ({
  [TooltipClasses.tooltip.css]: {
    backgroundColor: Colors.black,
    color: Colors.white,
    ...theme.typography.captionMedium,
    padding: '2px 8px',
    borderRadius: 4,
    maxWidth: 350,
  },

  [TooltipClasses.arrow.css]: {
    color: Colors.black,
  },
}));
